import React from 'react';
import css from './FiltersStrip.module.css';
import TagsFilter from '../TagsFilter/TagsFilter';

const FiltersStrip = ({ currentQueryParams, onSubmit, sortBy }) => {
  return (
    <div className={css.wrapper}>
      <h1 className={css.title}>Browse 3d scans</h1>
      <p className={css.subtitle}>
        Search by <span className={css.subtitleHighlight}>location</span>,{' '}
        <span className={css.subtitleHighlight}>industry</span> or{' '}
        <span className={css.subtitleHighlight}>scan type</span>.
      </p>
      <div className={css.searchWrapper}>
        <TagsFilter initialValues={currentQueryParams} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default FiltersStrip;
